(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tweens-festive-3"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('tweens-festive-three-quantity')) return;
  class TweensFestiveThree extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.s = this.config.strings;
      this.step = 1;
      this.band = '';
      this.cup = '';
      this.selected = new Map();
      this.quantities = new Map();
      this.choices = new Map();
      this.busy = false;
      this.added = false;
      this.uncertain = false;
      this.bundle = this.querySelector('[data-bundle]');
      this.gallery = this.querySelector('[data-gallery]');
      this.products = this.config.products.map(p => this.prepareProduct(p));
      this.cartItems = [...this.q('main-grid').querySelectorAll('[data-cart-item]')].map(card => ({
        key: card.dataset.cartKey, variantId: Number(card.querySelector('.tf3-remove')?.dataset.cartVariantId), productId: Number(card.dataset.productId), title: card.dataset.cartTitle,
        variantTitle: card.dataset.cartVariant, image: card.dataset.cartImage
      }));
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      const resizeBundle = () => { this.syncBundleViewport(); this.syncGalleryViewport(); };
      window.addEventListener('resize', resizeBundle, opts);
      window.visualViewport?.addEventListener('resize', resizeBundle, opts);
      window.visualViewport?.addEventListener('scroll', resizeBundle, opts);
      this.addEventListener('click', e => this.onClick(e), opts);
      this.addEventListener('change', e => this.onChange(e), opts);
      [this.bundle, this.gallery].forEach(dialog => {
        dialog.addEventListener('cancel', e => { if (this.busy && dialog === this.bundle) e.preventDefault(); }, opts);
        dialog.addEventListener('close', () => this.afterClose(dialog), opts);
        dialog.addEventListener('click', e => {
          if (e.target !== dialog || this.busy) return;
          const rect = dialog.getBoundingClientRect();
          if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close();
        }, opts);
      });
      this.gallery.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.moveGallery(e.key === 'ArrowLeft' ? -1 : 1); }
      }, opts);
      const stage = this.q('gallery-stage');
      stage.addEventListener('pointerdown', e => { this.swipeStart = { x: e.clientX, y: e.clientY }; }, opts);
      stage.addEventListener('pointerup', e => {
        if (!this.swipeStart) return;
        const dx = e.clientX - this.swipeStart.x;
        const dy = e.clientY - this.swipeStart.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) this.moveGallery(dx > 0 ? -1 : 1);
        this.swipeStart = null;
      }, opts);
      this.querySelectorAll('[data-action="open"]').forEach(el => { el.disabled = !this.products.length; });
      this.updateMain();
      window.addEventListener('pageshow', () => this.refreshCart(), opts);
      window.addEventListener('focus', () => this.refreshCart(), opts);
      ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxProduct:added'].forEach(event =>
        document.addEventListener(event, e => {
          if (e.detail?.cart?.items) {
            this.cartItems = e.detail.cart.items.slice(0, 3).map(item => this.normaliseCartItem(item));
            this.updateMain();
          } else this.refreshCart();
        }, opts));
      this.refreshCart();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.bundle?.close();
      this.gallery?.close();
      this.unlockScroll();
      this.ready = false;
    }
    syncBundleViewport() {
      if (!this.bundle?.open) return;
      const mobile = window.matchMedia('(max-width: 600px), (max-width: 989px) and (max-height: 600px) and (pointer: coarse)').matches;
      if (!mobile) {
        ['height', 'min-height', 'max-height', '--tf3-popup-top'].forEach(name => this.bundle.style.removeProperty(name));
        return;
      }
      const viewport = window.visualViewport;
      const height = Math.max(1, Math.floor((viewport?.height || window.innerHeight) - 24));
      ['height', 'min-height', 'max-height'].forEach(name => this.bundle.style.setProperty(name, height + 'px', 'important'));
      this.bundle.style.setProperty('--tf3-popup-top', ((viewport?.offsetTop || 0) + 12) + 'px');
    }
    syncGalleryViewport() {
      if (!this.gallery?.open) return;
      const mobile = window.matchMedia('(max-width: 600px), (max-width: 989px) and (max-height: 600px) and (pointer: coarse)').matches;
      if (!mobile) {
        ['height', 'min-height', 'max-height', '--tf3-popup-top'].forEach(name => this.gallery.style.removeProperty(name));
        return;
      }
      const viewport = window.visualViewport;
      const height = Math.max(1, Math.floor((viewport?.height || window.innerHeight) - 24));
      ['height', 'min-height', 'max-height'].forEach(name => this.gallery.style.setProperty(name, height + 'px', 'important'));
      this.gallery.style.setProperty('--tf3-popup-top', ((viewport?.offsetTop || 0) + 12) + 'px');
    }
    q(name) { return this.querySelector(`[data-${name}]`); }
    t(key, values = {}) {
      let value = this.s[key] || key;
      for (const [name, replacement] of Object.entries(values)) value = value.replaceAll(`__${name.toUpperCase()}__`, String(replacement)).replaceAll(new RegExp(`\\{\\{\\s*${name}\\s*\\}\\}`, 'g'), String(replacement));
      return value;
    }
    normal(value) { return String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' '); }
    canonicalCup(value) {
      const cup = String(value || '').toUpperCase().replace(/[\s()-]/g, '');
      return ['DD', 'E', 'DD/E', 'E/DD'].includes(cup) ? 'DD/E' : cup;
    }
    indexOfOption(options, names) {
      const aliases = String(names || '').split(',').map(n => this.normal(n));
      return (options || []).findIndex(n => aliases.includes(this.normal(n?.name ?? n)));
    }
    bandValue(value) {
      const text = String(value?.value ?? value ?? '').trim().toUpperCase()
        .replace(/^(?:BRA\s*SIZE|BAND\s*SIZE|BAND|SIZE)\s*[:=-]?\s*/i, '')
        .replace(/\s*(?:INCHES|INCH|IN|["″])$/i, '').trim();
      return /^\d{2,3}$/.test(text) ? String(Number(text)) : '';
    }
    cupValue(value) {
      const text = String(value?.value ?? value ?? '').trim().toUpperCase()
        .replace(/^CUP(?:\s*SIZE)?\s*[:=-]?\s*/i, '').replace(/\s*CUP$/i, '');
      const cup = this.canonicalCup(text);
      return /^(AA|A|B|C|D|DD\/E|DDD|F|G|H|I|J|K)$/.test(cup) ? cup : '';
    }
    combinedFit(value) {
      const text = String(value?.value ?? value ?? '').toUpperCase()
        .replace(/^(?:BRA\s*SIZE|SIZE)\s*[:=-]?\s*/i, '')
        .replace(/[\s()]/g, '').replace(/[–—]/g, '-');
      const match = text.match(/^(\d{2,3})[-/]?(AA|DDD|DD|[A-K])(?:\/(?:(\d{2,3}))?(DD|E))?$/);
      if (!match || (match[3] && match[3] !== match[1])) return null;
      if (match[4] && !['DD/E', 'E/DD'].includes(`${match[2]}/${match[4]}`)) return null;
      return { band: String(Number(match[1])), cup: this.canonicalCup(match[4] ? `${match[2]}/${match[4]}` : match[2]) };
    }
    prepareProduct(p) {
      p.options = (p.options || []).map(option => String(option?.name ?? option));
      const bi = this.indexOfOption(p.options, this.config.bandNames);
      const ci = this.indexOfOption(p.options, this.config.cupNames);
      const colour = this.indexOfOption(p.options, this.config.colourNames);
      const unsupported = p.requiresSellingPlan || p.variantCount > 250;
      p.variants = p.variants.map(v => {
        const rawOptions = Array.isArray(v.options) && v.options.length ? v.options : [v.option1, v.option2, v.option3].filter(value => value != null);
        const options = rawOptions.map(value => String(value?.value ?? value ?? '').trim());
        let band = '', cup = '';
        if (bi >= 0) {
          const value = options[bi] || '';
          const fit = this.combinedFit(value);
          if (fit) { band = fit.band; cup = fit.cup; }
          else band = this.bandValue(value);
        }
        if (ci >= 0) {
          const fit = this.combinedFit(options[ci]);
          if (fit) { if (!band) band = fit.band; cup = fit.cup; }
          else {
            cup = this.cupValue(options[ci]);
          }
        }
        if (!band || !cup) {
          options.forEach((value, index) => {
            if (index === colour) return;
            const fit = this.combinedFit(value);
            if (fit) { if (!band) band = fit.band; if (!cup) cup = fit.cup; }
            else {
              if (!band) band = this.bandValue(value);
              if (!cup) cup = this.cupValue(value);
            }
          });
        }
        const rule = v.quantityRule || v.quantity_rule || {};
        const unitAllowed = (!rule.min || rule.min <= 1) && (!rule.increment || rule.increment === 1) && (rule.max == null || rule.max >= 1);
        const available = Boolean(v.available && band && /^(AA|A|B|C|D|DD\/E|DDD|F|G|H|I|J|K)$/.test(cup) && !unsupported && unitAllowed);
        const detail = options.filter((value, index) => index !== bi && index !== ci && !this.combinedFit(value));
        return { ...v, options, image: typeof v.image === 'string' ? v.image : v.featured_image?.src || null, band, cup, available, colour: colour >= 0 ? options[colour] : '', label: detail.join(' · ') || options.join(' · ') };
      });
      return p;
    }
    matching(p) { return p.variants.filter(v => v.available && v.band === this.band && v.cup === this.cup); }
    bands() { return [...new Set(this.products.flatMap(p => p.variants.filter(v => v.available).map(v => v.band)))].sort((a,b) => Number(a)-Number(b)); }
    cups() {
      const order = ['AA','A','B','C','D','DD/E','DDD','F','G','H','I','J','K'];
      return [...new Set(this.products.flatMap(p => p.variants.filter(v => v.available && v.band === this.band).map(v => v.cup)))].sort((a,b) => order.indexOf(a)-order.indexOf(b));
    }
    offerNote() { return this.t('terms'); }
    node(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text != null) node.textContent = text;
      return node;
    }
    button(action, className, text, product) {
      const b = this.node('button', className, text);
      b.type = 'button'; b.dataset.action = action;
      if (product != null) b.dataset.product = product;
      return b;
    }
    badgeText(title) {
      const value = String(title || '').toLowerCase().trim();
      const model = value.includes('sb-') ? value.split('sb-').pop().split(')')[0].split('-')[0].split(' ')[0].trim() : '';
      switch (model) {
        case '938': case '968': case '935': return 'BEST SELLER';
        case '915': case '918': return 'TOP SELLER';
        case '5801': case '5802': case '5803': case '5804': case '5805': case '5806': case '58011': case '97015': case '93510': return 'NEW ARRIVALS';
        case '9203': case '9303': return 'HIGHLY REPEAT';
        default: return 'MOST LOVED';
      }
    }
    productBadge(title) {
      return this.node('span', 'tf3-product-badge', this.badgeText(title));
    }
    imageButton(p, v) {
      const button = this.button('preview', 'tf3-image-button', null, p.id);
      button.setAttribute('aria-label', this.t('preview', { name: p.title }));
      const src = v?.image || p.images[0]?.src;
      if (src) {
        const img = this.node('img', 'tf3-product-image');
        img.src = src; img.alt = p.images[0]?.alt || p.title; img.loading = 'lazy'; img.width = 480; img.height = 540;
        button.append(img);
      } else button.textContent = this.t('no_images');
      button.append(this.productBadge(p.title));
      return button;
    }
    normaliseCartItem(item) {
      const title = item.product_title || item.title || '';
      const image = typeof item.image === 'string' ? item.image : item.featured_image?.url || '';
      return { key: item.key, variantId: item.variant_id || item.id, productId: Number(item.product_id), title, variantTitle: item.variant_title || '', image };
    }
    async refreshCart() {
      try {
        const cart = await this.request('cart.js');
        if (!this.isConnected) return cart;
        this.cartItems = (cart.items || []).slice(0, 3).map(item => this.normaliseCartItem(item));
        this.updateMain();
        return cart;
      } catch { return null; }
    }
    updateMain() {
      const items = (this.cartItems || []).slice(0, 3);
      this.q('main-grid').replaceChildren(...[0, 1, 2].map(index => {
        const item = items[index];
        const card = this.node('article', item ? 'tf3-card' : 'tf3-card tf3-card--empty');
        if (!item) {
          const empty = this.button('open', 'tf3-empty-trigger');
          empty.disabled = !this.products.length;
          empty.setAttribute('aria-label', this.t('complete'));
          const plus = this.node('span', '', '+'); plus.setAttribute('aria-hidden', 'true');
          empty.append(plus);
          card.append(empty, this.node('span', 'tf3-slot-caption', ['Saree day', 'Garba night', 'Everyday'][index]));
          return card;
        }
        const product = this.products.find(p => p.id === item.productId);
        const preview = this.button('preview', 'tf3-image-button', null, item.productId);
        preview.setAttribute('aria-label', this.t('preview', { name: item.title }));
        if (item.image) {
          const img = this.node('img', 'tf3-product-image');
          img.src = item.image; img.alt = item.title; img.loading = 'lazy'; img.width = 480; img.height = 540;
          preview.append(img);
        } else if (product?.images[0]?.src) {
          const img = this.node('img', 'tf3-product-image');
          img.src = product.images[0].src; img.alt = product.images[0].alt || item.title;
          img.loading = 'lazy'; preview.append(img);
        }
        else preview.textContent = item.title;
        preview.append(this.productBadge(item.title));
        const bottom = this.node('div', 'tf3-card-bottom');
        bottom.append(this.button('preview', 'tf3-name', item.title, item.productId));
        const plus = this.button('open', 'tf3-plus', '+');
        plus.disabled = !this.products.length;
        plus.setAttribute('aria-label', this.t('complete'));
        const remove = this.button('remove-cart', 'tf3-remove', '×');
        remove.dataset.cartKey = item.key || '';
        remove.dataset.cartVariantId = String(item.variantId || '');
        remove.setAttribute('aria-label', `Remove ${item.title}`);
        remove.disabled = this.removingCart || !item.key;
        bottom.append(this.node('span', 'tf3-main-variant', item.variantTitle), plus); card.append(preview, bottom, remove); return card;
      }));
      const count = items.length;
      this.q('main-count').textContent = this.t('added_count',{count});
      const progress = this.q('progress');
      progress.setAttribute('aria-valuenow',count);
      progress.setAttribute('aria-label',this.t('added_count',{count}));
      [...progress.children].forEach((el,i) => el.classList.toggle('is-filled',i<count));
      this.q('main-note').textContent = this.cartNotice || this.offerNote();
      this.querySelectorAll('[data-price]').forEach(el => {
        el.hidden = this.config.currency !== this.config.offerCurrency;
        el.textContent = this.config.priceLabel;
      });
    }
    lockScroll() {
      if (this.hasScrollLock) return;
      const shared = window.__tweensFestiveScroll || (window.__tweensFestiveScroll = { count: 0, overflow: '' });
      if (shared.count++ === 0) { shared.overflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
      this.hasScrollLock = true;
    }
    unlockScroll() {
      if (!this.hasScrollLock) return;
      const shared = window.__tweensFestiveScroll;
      if (shared && --shared.count === 0) document.body.style.overflow = shared.overflow;
      this.hasScrollLock = false;
    }
    afterClose(dialog) {
      if (dialog === this.gallery) {
        this.galleryOrigin?.focus({preventScroll:true});
        if (!this.bundle.open) this.unlockScroll();
      } else {
        if (!this.gallery.open) this.unlockScroll();
        if (!this.handingOff) this.origin?.focus({preventScroll:true});
      }
    }
    async loadAvailableProducts() {
      const results = await Promise.allSettled(this.config.products.map(async product => {
        const url = new URL(product.url, window.location.origin);
        url.pathname = url.pathname.replace(/\.js$/, '') + '.js';
        url.search = '';
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(this.t('stock'));
        const data = await response.json();
        return this.prepareProduct({ ...product, options: data.options || product.options, variants: data.variants || [], requiresSellingPlan: data.requires_selling_plan ?? product.requiresSellingPlan });
      }));
      this.products = results.map((result, index) => result.status === 'fulfilled' ? result.value : this.prepareProduct({ ...this.config.products[index], variants: [] }));
      if (!this.bands().includes(this.band)) { this.band = ''; this.cup = ''; }
      else if (!this.cups().includes(this.cup)) this.cup = '';
      this.revalidate();
      return results.every(result => result.status === 'fulfilled');
    }
    async open(origin, productId) {
      if (this.loadingProducts) return;
      if (!this.products.length) return;
      this.refreshCart();
      this.handingOff = false;
      this.origin = origin;
      this.pendingProduct = productId ? Number(productId) : null;
      if (!this.band) this.step = 1;
      else if (!this.cup) this.step = 2;
      else this.step = 3;
      this.message('');
      this.renderStep();
      this.lockScroll(); this.bundle.showModal();
      this.syncBundleViewport();
      requestAnimationFrame(() => this.syncBundleViewport());
      if (!this.added && !this.uncertain) {
        this.loadingProducts = true; this.busy = true; this.updateFooter();
        this.q('fit-options').hidden = true; this.q('products').hidden = true;
        this.message(this.t('loading_sizes'));
        try {
          const complete = await this.loadAvailableProducts();
          this.step = !this.band ? 1 : !this.cup ? 2 : 3;
          this.message(complete ? '' : this.t('stock'), !complete);
        } finally {
          this.loadingProducts = false; this.busy = false; this.renderStep();
        }
      }
      this.q('heading').focus();
      this.scrollToPending();
    }
    goStep(step) {
      if (this.busy || this.added || this.uncertain || (step >= 2 && !this.band) || (step === 3 && !this.cup)) return;
      this.step = step; this.renderStep(); this.q('scroll').scrollTop = 0; this.q('heading').focus(); this.scrollToPending();
    }
    scrollToPending() {
      if (this.step !== 3 || !this.pendingProduct) return;
      const card = this.q('products').querySelector(`[data-card="${this.pendingProduct}"]`);
      card?.scrollIntoView({block:'nearest',behavior:'auto'});
      this.pendingProduct = null;
    }
    message(text, error = false) {
      const el = this.q('message'); el.textContent = text; el.hidden = !text; el.classList.toggle('is-error',error);
    }
    renderStep() {
      const key = this.step === 1 ? 'size' : this.step === 2 ? 'cup' : 'choose';
      this.q('heading').textContent = this.t(`${key}_heading`);
      this.q('help').textContent = this.t(`${key}_help`);
      this.q('step-label').textContent = this.t('current_step',{index:this.step});
      this.querySelectorAll('[data-action="step"]').forEach(b => {
        const step = Number(b.dataset.step);
        b.disabled = this.busy || this.added || this.uncertain || (step>1 && !this.band) || (step>2 && !this.cup);
        if (step === this.step) b.setAttribute('aria-current','step'); else b.removeAttribute('aria-current');
      });
      const options = this.q('fit-options'); options.hidden = this.step === 3;
      this.q('products').hidden = this.step !== 3;
      if (this.step === 3) this.renderProducts();
      else {
        const values = this.step === 1 ? this.bands() : this.cups();
        const fieldset = this.node('fieldset');
        fieldset.append(this.node('legend','tf3-sr',this.t(`${key}_heading`)));
        values.forEach((value,i) => {
          const wrap = this.node('div','tf3-fit-choice');
          const input = this.node('input'); input.type = 'radio'; input.name = `${this.config.id}-${key}`;
          input.id = `${this.id}-${key}-${i}`; input.value = value; input.dataset.fit = key;
          input.checked = (key === 'size' ? this.band : this.cup) === value;
          const label = this.node('label','',value); label.htmlFor = input.id;
          wrap.append(input,label); fieldset.append(wrap);
        });
        options.replaceChildren(fieldset);
        if (!values.length) this.message(this.t('no_sizes'),true);
      }
      this.updateFooter();
    }
    selectedTotal() {
      return [...this.selected.keys()].reduce((total, id) => total + (this.quantities.get(id) || 1), 0);
    }
    quantityLimit(id) {
      const p = this.products.find(p => p.id === id);
      const v = p?.variants.find(v => v.id === (this.selected.get(id) || this.choices.get(id)));
      const rule = v?.quantityRule || v?.quantity_rule || {};
      return Math.min(3, rule.max == null ? 3 : Number(rule.max));
    }
    setProductQuantity(id, value) {
      if (this.busy || this.added || this.uncertain) return;
      const old = this.selected.has(id) ? (this.quantities.get(id) || 1) : 0;
      const quantity = Math.max(0, Math.min(this.quantityLimit(id), Math.floor(value)));
      if (this.selectedTotal() - old + quantity > 3) { this.message(this.t('full')); this.updateSelectionUI(); return; }
      if (quantity) {
        this.selected.set(id, this.choices.get(id)); this.quantities.set(id, quantity);
      } else {
        this.selected.delete(id); this.quantities.delete(id);
      }
      const total = this.selectedTotal();
      this.message(total === 3 ? this.t('full') : total ? this.t('choose_more', { count: 3 - total }) : '');
      this.updateSelectionUI();
    }
    renderProducts() {
      const eligible = this.products.filter(p => this.matching(p).length);
      this.q('products').replaceChildren(...eligible.map(p => this.productCard(p)));
      if (!eligible.length) this.message(this.t('no_match'),true);
      else if (eligible.reduce((total, p) => total + this.quantityLimit(p.id), 0) < 3) this.message(this.t('few_match',{count:eligible.length}));
    }
    productCard(p) {
      const matches = this.matching(p);
      let choice = matches.find(v => v.id === this.selected.get(p.id)) || matches.find(v => v.id === this.choices.get(p.id)) || matches[0];
      this.choices.set(p.id,choice.id);
      const card = this.node('article','tf3-pick'); card.dataset.card = p.id;
      card.classList.toggle('is-selected',this.selected.has(p.id));
      card.append(this.imageButton(p,choice),this.node('span','tf3-preview-hint',this.t('preview_hint')));
      const body = this.node('div','tf3-pick-body'); body.append(this.button('preview','tf3-name',p.title,p.id));
      const label = this.node('label','tf3-variant-label',choice.colour ? this.t('colour') : this.t('variant'));
      label.htmlFor = `${this.id}-variant-${p.id}`;
      const select = this.node('select','tf3-variant-select'); select.id=label.htmlFor; select.dataset.variant=p.id;
      matches.forEach(v => { const opt = this.node('option','',v.label); opt.value=v.id; opt.selected=v.id===choice.id; select.append(opt); });
      body.append(label,select);
      const selectLabel = this.node('label','tf3-select-control');
      const checkbox = this.node('input'); checkbox.type='checkbox'; checkbox.dataset.select=p.id; checkbox.checked=this.selected.has(p.id);
      checkbox.setAttribute('aria-label',this.t('select_product',{name:p.title}));
      const status = this.node('span','',this.t(checkbox.checked?'selected':'select')); status.dataset.selectionLabel='';
      const quantityRow = this.node('div', 'tf3-quantity-row');
      quantityRow.append(this.node('span', 'tf3-variant-label', this.t('quantity')));
      const controls = this.node('div', 'tf3-quantity-control');
      const minus = this.button('quantity-minus', '', '−', p.id);
      minus.setAttribute('aria-label', this.t('decrease_quantity', { name: p.title }));
      const value = this.node('output', '', this.selected.has(p.id) ? (this.quantities.get(p.id) || 1) : 0);
      value.dataset.quantityValue = ''; value.setAttribute('aria-live', 'polite');
      value.setAttribute('aria-label', this.t('quantity'));
      const plus = this.button('quantity-plus', '', '+', p.id);
      plus.setAttribute('aria-label', this.t('increase_quantity', { name: p.title }));
      minus.disabled = Number(value.textContent) === 0;
      plus.disabled = this.selectedTotal() >= 3 || Number(value.textContent) >= this.quantityLimit(p.id);
      controls.append(minus, value, plus); quantityRow.append(controls);
      selectLabel.append(checkbox,status); body.append(selectLabel, quantityRow); card.append(body); return card;
    }
    updateSelectionUI() {
      this.q('products').querySelectorAll('[data-card]').forEach(card => {
        const active = this.selected.has(Number(card.dataset.card));
        card.classList.toggle('is-selected',active);
        card.querySelector('[data-select]').checked=active;
        card.querySelector('[data-selection-label]').textContent=this.t(active?'selected':'select');
        card.querySelector('[data-quantity-value]').textContent = active ? (this.quantities.get(Number(card.dataset.card)) || 1) : 0;
      });
      this.updateFooter(); this.updateMain();
    }
    updateFooter() {
      this.q('footer-summary').hidden=this.step!==3;
      this.q('count').textContent=this.t('selected_count',{count:this.selectedTotal()});
      this.q('fit').textContent=this.t('fit',{band:this.band,cup:this.cup});
      this.q('offer-note').textContent=this.offerNote();
      const back = this.querySelector('[data-action="back"]'); back.hidden=this.step===1 || this.added || this.uncertain; back.disabled=this.busy;
      const submit=this.q('bundle').querySelector('.tf3-submit');
      submit.dataset.action=this.added?'view':this.uncertain?'check':this.step===3?'add':'continue';
      submit.textContent=this.t(this.busy?'loading':this.added?'retry_view':this.uncertain?'check_cart':this.step===3?'add':'continue');
      submit.disabled=this.busy || (!this.added && !this.uncertain && (this.step===1?!this.band:this.step===2?!this.cup:this.selectedTotal()!==3));
      this.bundle.setAttribute('aria-busy',String(this.busy));
      this.q('cart-link').hidden=!this.added&&!this.uncertain;
      this.querySelector('[data-action="close"]').disabled=this.busy;
      this.q('products').querySelectorAll('input,select').forEach(el => { el.disabled=this.busy||this.added||this.uncertain; });
      this.q('products').querySelectorAll('[data-card]').forEach(card => {
        const id = Number(card.dataset.card), quantity = this.selected.has(id) ? (this.quantities.get(id) || 1) : 0;
        const locked = this.busy || this.added || this.uncertain;
        card.querySelector('[data-action="quantity-minus"]').disabled = locked || quantity === 0;
        card.querySelector('[data-action="quantity-plus"]').disabled = locked || this.selectedTotal() >= 3 || quantity >= this.quantityLimit(id);
      });
      this.querySelectorAll('[data-action="step"]').forEach(b=> { if(this.busy||this.added||this.uncertain)b.disabled=true; });
    }
    revalidate() {
      const removed=[],changed=[];
      for(const [id,variantId] of this.selected) {
        const p=this.products.find(p=>p.id===id), matches=this.matching(p);
        if(!matches.length) { this.selected.delete(id); this.quantities.delete(id); removed.push(p.title); }
        else if(!matches.some(v=>v.id===variantId)) {
          const old=p.variants.find(v=>v.id===variantId);
          const next=matches.find(v=>v.colour===old?.colour && v.label===old?.label)||matches.find(v=>v.colour===old?.colour)||matches[0];
          this.selected.set(id,next.id); this.choices.set(id,next.id); this.quantities.set(id, Math.min(this.quantities.get(id) || 1, this.quantityLimit(id))); changed.push(p.title);
        }
      }
      const messages=[];
      if(removed.length)messages.push(this.t('removed',{names:removed.join(', ')}));
      if(changed.length)messages.push(this.t('changed'));
      this.message(messages.join(' ')); this.updateMain();
    }
    onChange(e) {
      if(this.busy||this.added||this.uncertain) {this.updateSelectionUI();return;}
      const target=e.target;
      if(target.dataset.fit) {
        if(target.dataset.fit==='size') {
          this.band=target.value;
          if(!this.cups().includes(this.cup))this.cup='';
        }else this.cup=target.value;
        this.revalidate(); this.updateFooter();
        this.querySelectorAll('[data-action="step"]').forEach(b=>{b.disabled=Number(b.dataset.step)>1&&!this.band || Number(b.dataset.step)>2&&!this.cup;});
      }else if(target.dataset.select) {
        const id=Number(target.dataset.select);
        this.setProductQuantity(id, target.checked ? 1 : 0);
      }else if(target.dataset.variant) {
        const id=Number(target.dataset.variant),variantId=Number(target.value);
        this.choices.set(id,variantId); if(this.selected.has(id)) { this.selected.set(id,variantId); this.quantities.set(id, Math.min(this.quantities.get(id) || 1, this.quantityLimit(id))); }
        const p=this.products.find(p=>p.id===id),card=target.closest('[data-card]');
        const img=card.querySelector('.tf3-product-image'),variant=p.variants.find(v=>v.id===variantId);
        if(img && (variant.image||p.images[0]?.src))img.src=variant.image||p.images[0].src;
        this.updateSelectionUI();
      }
    }
    onClick(e) {
      const b=e.target.closest('[data-action]'); if(!b || !this.contains(b)||b.disabled)return;
      if (b.dataset.action === 'view' || b.dataset.action === 'check') { e.preventDefault(); e.stopImmediatePropagation(); }
      switch(b.dataset.action) {
        case 'quantity-minus':
        case 'quantity-plus': {
          const id = Number(b.dataset.product);
          const quantity = this.selected.has(id) ? (this.quantities.get(id) || 1) : 0;
          this.setProductQuantity(id, quantity + (b.dataset.action === 'quantity-plus' ? 1 : -1));
          break;
        }
        case 'open':this.open(b,b.dataset.product);break;
        case 'close':if(!this.busy)this.bundle.close();break;
        case 'continue':this.goStep(this.step+1);break;
        case 'back':this.goStep(this.step-1);break;
        case 'step':this.goStep(Number(b.dataset.step));break;
        case 'preview':this.openGallery(Number(b.dataset.product),b);break;
        case 'gallery-close':this.gallery.close();break;
        case 'gallery-prev':this.moveGallery(-1);break;
        case 'gallery-next':this.moveGallery(1);break;
        case 'gallery-index':this.galleryIndex=Number(b.dataset.index);this.renderGallery();break;
        case 'add':this.addKit();break;
        case 'view':this.viewCart();break;
        case 'check':this.viewCart();break;
      }
    }
    openGallery(id,origin) {
      this.galleryProduct=this.products.find(p=>p.id===id);
      if (!this.galleryProduct) {
        const item=this.cartItems.find(item=>item.productId===id);
        if (item) this.galleryProduct={title:item.title,images:item.image?[{src:item.image,alt:item.title}]:[]};
      }
      if(!this.galleryProduct)return;
      this.galleryOrigin=origin;this.galleryIndex=0;this.renderGallery();this.lockScroll();this.gallery.showModal();
      this.syncGalleryViewport();
      requestAnimationFrame(() => this.syncGalleryViewport());
      this.q('gallery-title').focus({preventScroll:true});
    }
    moveGallery(amount) {
      const count=this.galleryProduct?.images.length||0;if(!count)return;
      this.galleryIndex=(this.galleryIndex+amount+count)%count;this.renderGallery();
    }
    renderGallery() {
      const p=this.galleryProduct, count=p.images.length;
      this.q('gallery-title').textContent=p.title;
      const current=p.images[this.galleryIndex];
      if(current) {const img=this.node('img');img.src=current.src;img.alt=current.alt;this.q('gallery-stage').replaceChildren(img);}
      else this.q('gallery-stage').textContent=this.t('no_images');
      this.q('gallery-position').textContent=count?this.t('image_position',{index:this.galleryIndex+1,count}):'';
      this.querySelectorAll('[data-action="gallery-prev"],[data-action="gallery-next"]').forEach(b=>b.disabled=count<2);
      const focusedIndex=document.activeElement?.dataset.action==='gallery-index'?Number(document.activeElement.dataset.index):null;
      this.q('thumbs').replaceChildren(...p.images.map((image,index)=>{
        const b=this.button('gallery-index','',null);b.dataset.index=index;b.setAttribute('aria-label',this.t('thumbnail',{index:index+1}));b.setAttribute('aria-current',String(index===this.galleryIndex));
        const img=this.node('img');img.src=image.src;img.alt='';img.loading='lazy';b.append(img);return b;
      }));
      if(focusedIndex!=null)this.q('thumbs').children[focusedIndex]?.focus({preventScroll:true});
    }
    async request(path,body) {
      const response=await fetch(this.config.root.replace(/\/?$/,'/')+path,{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},credentials:'same-origin',...(body?{body:JSON.stringify(body)}:{})});
      const data=await response.json();
      if(!response.ok){const error=new Error(data.description||data.message||this.t('error'));error.status=response.status;throw error;}
      return data;
    }
    findDrawer() {
      for (const selector of [this.config.drawerSelector, 'hdt-cart-drawer', '#hdt-cart-drawer', '#hdt-drawer-cart', '#CartDrawer', 'cart-drawer', '#t4s-mini_cart']) {
        try { const drawer = selector && document.querySelector(selector); if (drawer) return drawer; } catch {}
      }
      return null;
    }
    findTrigger() {
      const selectors = [this.config.triggerSelector, '[aria-controls="hdt-cart-drawer"]', '[aria-controls="hdt-drawer-cart"]', '[aria-controls="CartDrawer"]', '[data-drawer-options*="t4s-mini_cart"]', '[aria-controls="t4s-mini_cart"]', '[data-drawer-id="#t4s-mini_cart"]'];
      for (const selector of selectors) {
        try {
          const trigger = [...document.querySelectorAll(selector || ':not(*)')].find(el => !this.contains(el) && !el.disabled);
          if (trigger && (trigger.tagName !== 'A' || trigger.hasAttribute('aria-controls') || trigger.hasAttribute('data-drawer-options') || trigger.hasAttribute('data-drawer-id'))) return trigger;
        } catch {}
      }
      return null;
    }
    async openNativeDrawer() {
      const trigger = this.findTrigger();
      const drawer = this.findDrawer();
      const nativeDrawer = drawer?.matches('hdt-cart-drawer') ? drawer : drawer?.closest('hdt-cart-drawer') || drawer;
      if (!trigger && !nativeDrawer) return false;
      if (!trigger && typeof nativeDrawer.open !== 'function' && !('show' in nativeDrawer)) return false;
      this.handingOff = true;
      this.bundle.close(); this.unlockScroll();
      await new Promise(resolve => requestAnimationFrame(resolve));
      if (trigger) {
        if (trigger.tagName === 'A') {
          trigger.addEventListener('click', event => event.preventDefault(), { capture: true, once: true });
        }
        trigger.click();
        return true;
      }
      if (typeof nativeDrawer.open === 'function') {
        nativeDrawer.open();
        return true;
      }
      const show = nativeDrawer.show;
      if (typeof show === 'function') show.call(nativeDrawer);
      return true;
    }
    sectionIds(drawer) {
      const ids=String(this.config.cartSections || '').split(',').map(v=>v.trim()).filter(Boolean);
      const sectionId=drawer?.getAttribute('section-id') || drawer?.getAttribute('data-section-id');
      if(sectionId)ids.push(sectionId);
      if(typeof drawer?.getSectionsToRender==='function')ids.push(...drawer.getSectionsToRender().map(s=>s.section||s.id));
      const wrapper=drawer?.closest('[id^="shopify-section-"]');
      if(wrapper)ids.push(wrapper.id.replace('shopify-section-',''));
      return [...new Set(ids)].filter(id=>/^[\w-]+$/.test(id)).slice(0,5);
    }
    showCartNotice(drawer) {
      if (!drawer || !this.cartNotice) return;
      drawer.querySelector('[data-tweens-kit-notice]')?.remove();
      const notice=this.node('p','tf3-cart-notice',this.cartNotice);
      notice.dataset.tweensKitNotice='';notice.setAttribute('role','status');
      const content=drawer.querySelector('.drawer__inner, [data-cart-content], .hdt-drawer__body')||drawer;
      content.prepend(notice);
    }
    async refreshDrawer(addResponse) {
      let drawer=this.findDrawer();if(!drawer)return this.openNativeDrawer();
      const ids=this.sectionIds(drawer);
      let sections={};
      if(ids.length){
        const url=new URL(window.location.href);url.searchParams.set('sections',ids.join(','));
        const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'}});
        if(!response.ok)throw new Error(this.t('drawer_error'));sections=await response.json();
      }
      if(typeof drawer.renderContents==='function' && ids.length && ids.every(id=>sections[id])) {
        drawer.setActiveElement?.(this.origin);
        this.handingOff=true;this.bundle.close();this.unlockScroll();
        drawer.renderContents({...addResponse,sections});
        return this.openNativeDrawer();
      }
      let refreshed=false;
      for(const [id,html]of Object.entries(sections)){
        if(!html)continue;
        const doc=new DOMParser().parseFromString(html,'text/html');
        const old=document.getElementById(`shopify-section-${id}`),next=doc.getElementById(`shopify-section-${id}`);
        if(old&&next&&!old.contains(this)){old.replaceChildren(...next.childNodes);refreshed=true;}
      }
      return this.openNativeDrawer();
    }
    async reconcile(token) {
      const cart=await this.request('cart.js');
      const lines=cart.items.filter(i=>i.properties?._tweens_kit===token);
      return {cart,quantity:lines.reduce((n,i)=>n+i.quantity,0)};
    }
    async addKit() {
      if(this.busy||this.added||this.uncertain||this.selectedTotal()!==3)return;
      this.busy=true;this.message('');this.updateFooter();
      const token=`${this.config.id}-${crypto.randomUUID()}`;
      let addAttempted=false;
      try {
        const fresh=await Promise.all([...this.selected.keys()].map(async id=>{
          const p=this.products.find(p=>p.id===id);
          const response=await fetch(p.url+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
          if(!response.ok)throw new Error(this.t('stock'));
          return {p,data:await response.json()};
        }));
        let changed=false;
        for(const {p,data}of fresh){
          p.variants.forEach(variant=>{if(!data.variants.find(v=>v.id===variant.id)?.available)variant.available=false;});
          const id=this.selected.get(p.id),v=data.variants.find(v=>v.id===id);
          if(!v?.available){this.selected.delete(p.id);this.quantities.delete(p.id);changed=true;}
        }
        if(changed){this.renderProducts();this.updateMain();throw new Error(this.t('stock'));}
        const items=[...this.selected].map(([productId,id])=>({id,quantity:this.quantities.get(productId)||1,properties:{_tweens_kit:token}}));
        addAttempted=true;
        let addResponse;
        try {addResponse=await this.request('cart/add.js',{items});}
        catch(error){
          try{
            const state=await this.reconcile(token);
            if(state.quantity===3){this.added=true;addResponse={items:state.cart.items.filter(i=>i.properties?._tweens_kit===token)};}
            else if(state.quantity===0 && error.status){addAttempted=false;throw error;}
            else {this.uncertain=true;throw new Error(this.t('uncertain'));}
          }catch(reconcileError){if(addAttempted&&!this.added)this.uncertain=true;throw reconcileError;}
        }
        this.added=true;this.lastAdd=addResponse;
        let cart=null;
        try{cart=await this.request('cart.js');}catch{}
        if (cart) this.cartItems=(cart.items||[]).slice(0,3).map(item=>this.normaliseCartItem(item));
        else this.refreshCart();
        this.cartNotice=this.t('success');
        this.message(this.cartNotice);
        this.lastCart=cart;this.dispatchEvent(new CustomEvent('tweens:kit-added',{bubbles:true,detail:{cart,kit:token}}));
        let opened=false;try{opened=await this.refreshDrawer(addResponse);}catch{opened=await this.openNativeDrawer();}
        if(!opened)this.message(this.cartNotice+' '+this.t('drawer_error'));
      }catch(error){this.message(error.message||this.t('error'),true);}
      finally{this.busy=false;this.updateFooter();this.updateMain();}
    }
    async viewCart() {
      if(this.busy)return;
      this.busy=true;this.updateFooter();
      let opened=false;
      try{opened=await this.refreshDrawer(this.lastAdd||{});}catch{opened=await this.openNativeDrawer();}
      finally{this.busy=false;this.updateFooter();}
      if(!opened)this.message(this.t('drawer_error'),true);
    }
  }
  customElements.define('tweens-festive-three-quantity',TweensFestiveThree);
})();

  } catch(e) { console.error(e); }
})();
})();
